import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { AddressItemType } from '@features/shipping-methods/types'

import Radio from '@shared/ui/radio'

import styles from './styles.module.scss'

interface AddressItemProps {
  address: AddressItemType;
  selected?: boolean;
  onSelect?: () => void;
}

export default function AddressItem ({
  address,
  selected = false,
  onSelect,
}: AddressItemProps) {
  const { t: to } = useTranslation('order')

  return (
    <div className={styles.item} onClick={onSelect}>
      <Radio radioSize="large" checked={selected} />

      <div className={styles.item__info}>
        {address.label && (
          <h3 className={styles.item__label}>{address.label}</h3>
        )}
        {address.address && (
          <span
            className={classNames(styles.item__address, {
              [styles['item__address--secondary']]: address.label,
            })}
          >
            {address.address}
          </span>
        )}

        <div className={styles.item__group}>
          {address.address_appartments && (
            <div className={styles['item__group-item']}>
              <span className={styles['item__group-name']}>
                {to('form.apartment')}:{' '}
              </span>
              <span className={styles['item__group-value']}>
                {address.address_appartments}
              </span>
            </div>
          )}

          {address.address_floor && (
            <div className={styles['item__group-item']}>
              <span className={styles['item__group-name']}>
                {to('form.floor')}:{' '}
              </span>
              <span className={styles['item__group-value']}>
                {address.address_floor}
              </span>
            </div>
          )}

          {address.address_porch && (
            <div className={styles['item__group-item']}>
              <span className={styles['item__group-name']}>
                {to('form.entrance')}:{' '}
              </span>
              <span className={styles['item__group-value']}>
                {address.address_porch}
              </span>
            </div>
          )}

          {address.address_intercom && (
            <div className={styles['item__group-item']}>
              <span className={styles['item__group-name']}>
                {to('form.intercom')}:{' '}
              </span>
              <span className={styles['item__group-value']}>
                {address.address_intercom}
              </span>
            </div>
          )}
        </div>

        <div className={styles.item__chips}>
          {address.recipient_name && address.recipient_phone && (
            <span className={styles.item__chip}>
              {address.recipient_name}, {address.recipient_phone}
            </span>
          )}
          {address.comment && (
            <span className={styles.item__chip}>{address.comment}</span>
          )}
        </div>
      </div>
    </div>
  )
}
